import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import FormHeader from "@/components/ui/organisms/MHeader";
import MSpacer from "@/components/ui/atoms/MSpacer";
import MFrame from "@/components/ui/atoms/MFrame";
import styles from "./settings.module.css";

const OSSLicenses: React.FC = () => {
  const memberInfo = useSelector(
    (state: RootState) => state.auth?.member || {}
  );

  const licenses = [
    {
      category: "Used on all platforms",
      items: [
        {
          name: "OpenCV",
          license: "Apache 2.0",
          url: "https://github.com/opencv/opencv/blob/4.x/LICENSE",
        },
        {
          name: "Crypto++",
          license: "Boost Software License 1.0",
          url: "https://github.com/weidai11/cryptopp/blob/master/License.txt",
        },
      ],
    },
    {
      category: "Used on Android & iOS",
      items: [
        {
          name: "TensorFlow",
          license: "Apache 2.0",
          url: "https://github.com/tensorflow/tensorflow/blob/master/LICENSE",
        },
      ],
    },
    {
      category: "Used only on Android (Document Scanner)",
      items: [
        {
          name: "Subsampling Scale Image View",
          license: "Apache 2.0",
          url: "https://github.com/davemorrissey/subsampling-scale-image-view/blob/master/LICENSE",
        },
      ],
    },
    {
      category: "Used only on Android (Data Extraction)",
      items: [
        {
          name: "Pdfium (Android binding)",
          license: "BSD + Apache",
          url: "https://github.com/barteksc/PdfiumAndroid/blob/master/LICENSE",
        },
      ],
    },
    {
      category: "Used only on Xamarin.Android",
      items: [
        {
          name: "Pdfium (Xamarin binding)",
          license: "BSD + Apache",
          url: "https://github.com/sbytedev/Net.Xamarin.Android.Pdfium/blob/develop/LICENSE",
        },
      ],
    },
  ];

  const getDescription = () => {
    return (
      <span>
        Maatra uses the Docutain SDK, which includes several open-source
        components. Their licenses are provided below in accordance with their
        terms.
      </span>
    );
  };

  return (
    <div className="profile-page-root">
      <FormHeader
        module="oss-licenses"
        memberInfo={memberInfo}
        title="OSS Licenses"
        description={getDescription()}
        hideBack
      />
      <MSpacer mt={24} />
      <div className="">
        {/* License Information Card */}
        <MFrame className={styles.consentInfoContainer}>
          <div className="flex-1">
            <h3 className="body-xs-medium" style={{ marginBottom: "32px" }}>
              Open Source libraries used in the Docutain SDK
            </h3>
            {licenses.map((section, idx) => (
              <div
                key={idx}
                style={{
                  marginBottom: idx < licenses.length - 1 ? "32px" : "0",
                }}
              >
                <p
                  className="body-xs-medium"
                  style={{ color: "#2A2A2A", marginBottom: "16px" }}
                >
                  {section.category}
                </p>
                {section.items.map((item, itemIdx) => (
                  <div
                    key={itemIdx}
                    style={{
                      marginBottom:
                        itemIdx < section.items.length - 1 ? "16px" : "0",
                      paddingLeft: "16px",
                    }}
                  >
                    <p
                      className="body-xs-medium"
                      style={{ color: "#2A2A2A", marginBottom: "4px" }}
                    >
                      {item.name}
                    </p>
                    <p
                      className="body-xs-medium"
                      style={{ color: "#2A2A2A", marginBottom: "4px" }}
                    >
                      Licensed under {item.license}
                    </p>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body-xs-semibold"
                      style={{ color: "#B23F83", textDecoration: "none" }}
                    >
                      View license
                    </a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </MFrame>
      </div>
    </div>
  );
};

export default OSSLicenses;
